import React from "react";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { ColumnFormatter } from "react-bootstrap-table-next";

export const PhoneNumberFormatter: ColumnFormatter<any, any, string> = (cell) => (
  <span>{formatPhoneNumberIntl(cell)}</span>
);
